import React from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import Section from './Section';

const ComingSoon = () => {
  const title = 'Coming Soon';
  const metaTitle = 'Coming Soon';
  const description = 'This page is Coming Soon.';
  // Hello world Prince fevjibecjibejhcb4jb
  return (
    <React.Fragment>
      <Helmet>
        <title>{metaTitle} | Webvi </title>
      </Helmet>
      <Section title={title} description={description} />
      <section className="section">
        <Container>
          <h2>{description}</h2>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default ComingSoon